import { isEmpty } from 'lodash';

import { formatDate } from './dates';

export function mapToDetails(changes) {
    if (isEmpty(changes)) {
        return null;
    }

    return changes.map(({ propertyName, from, to }) => ({
        propertyName: mapPropertyName(propertyName),
        from: mapValue(propertyName, from),
        to: mapValue(propertyName, to)
    }));
}

const propertyNames = {
    VirtualMachineId: 'virtualMachine',
    DeviceId: 'device',
    DeviceTypeName: 'deviceType',
    DeviceTypeId: 'deviceType',
    SerialNumber: 'serialNumber',
    InventoryNumber: 'inventoryNumber',
    IsPrimary: 'primaryDevice',
    IsOrdered: 'licenseOrdered',
    Description: 'description',
    LocationId: 'location',
    DeliveryDate: 'deliveryDate',
    DeviceManufacturerId: 'deviceManufacturerId',
    AssignmentDate: 'assignmentDate',
    AdminName: 'adminName',
    UserName: 'userName',
    WorkingStateId: 'condition',
    Comments: 'comments',
    StateId: 'state',
    OsVersionId: 'osVersion',
    ScreenId: 'screen',
    ProjectName: 'project',
    UserId: 'user',
    AvailableLicenses: 'availableLicenses',
    ExpirationDate: 'expirationDate',
    LicenseTypeId: 'licenseType',
    LicenseManufacturerId: 'licenseManufacturerName',
    Name: 'productName',
    LicenseNumber: 'licenseNumber',
    TotalLicenses: 'totalLicenses',
    LicenseLocations: 'licenseLocations',
    ProjectId: 'project',
    JiraTicketNumber: 'jiraTicketNumber',
    ReturnDate: 'returnDate',
    ResourceOwnerId: 'resourceOwner',
};

function mapPropertyName(propertyName) {
    return propertyNames[propertyName] || propertyName;
}

function mapValue(prop, value) {
    switch (prop) {
        case 'DeliveryDate':
            return formatDate(value);
        case 'AssignmentDate':
            return formatDate(value);
        case 'ExpirationDate':
            return formatDate(value);
        case 'ReturnDate':
            return formatDate(value);
        case 'WriteOffDate':
            return formatDate(value);
        default:
            return value;
    }
}
